import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import "./HaqtSelect.scss";

const HaqtSelect = ({
  name,
  options,
  label,
  onChange,
  onBlur,
  value,
  error,
  helperText,
  hideClearIndicator,
  disabled,
  selectStyles = {},
}) => {
  return (
    <div style={selectStyles}>
      <Autocomplete
        disabled={disabled}
        fullWidth
        name={name}
        value={value}
        onChange={onChange}
        onBlur={() => onBlur && onBlur({ target: { name: name } })}
        options={options}
        disableClearable={hideClearIndicator}
        renderInput={(params) => (
          <TextField
            {...params}
            value={value}
            label={label}
            variant="outlined"
            error={error}
            helperText={helperText}
          />
        )}
      />
    </div>
  );
};

export default HaqtSelect;
